import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalPlanilhaVeiculos",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-scrollable modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"15px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgb(236, 236, 236)"},
  class: "p-3 rounded"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"height":"fit-content","width":"fit-content","font-size":"18px","color":"#203972 !important"},
    class: "m-0 fas fa-pencil-alt"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 subtitulo cor_texto_1" }, "Detalhes da planilha", -1)
const _hoisted_9 = { class: "m-0 legenda text-muted" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  height: "2em",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body background_2",
  style: {"height":"400px"},
  id: "modalBody"
}
const _hoisted_13 = { class: "d-flex flex-column gap-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Informações da planilha", -1)
const _hoisted_15 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, "Nome:", -1)
const _hoisted_17 = { class: "texto text-muted" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "my-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, "Status:", -1)
const _hoisted_19 = { class: "texto text-muted" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Detalhe do erro", -1)
const _hoisted_21 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1"
}
const _hoisted_22 = {
  key: 0,
  class: "m-0 texto bold text-muted",
  style: {"padding":"2rem","text-align":"center"}
}
const _hoisted_23 = {
  key: 1,
  class: "mb-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden"
}
const _hoisted_24 = {
  key: 2,
  class: ""
}
const _hoisted_25 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5 gap-4" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  fill: "white",
  viewBox: "0 0 512 512"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  fill: "white",
  viewBox: "0 0 512 512"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", { d: "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.arquivo.data ? `Adicionado ${new Date(_ctx.arquivo.data).toLocaleString('pt-BR')}` : 'Data desconhecida'), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("section", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.arquivo.nome), 1),
                _hoisted_18,
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.arquivo.status), 1)
              ]),
              _hoisted_20,
              _createElementVNode("section", _hoisted_21, [
                (!_ctx.arquivo.erro)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Não foi encontrado erro."))
                  : _createCommentVNode("", true),
                (_ctx.arquivo.erro)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_23, "Erro:"))
                  : _createCommentVNode("", true),
                (_ctx.arquivo.erro)
                  ? (_openBlock(), _createElementBlock("code", _hoisted_24, _toDisplayString(_ctx.arquivo.detalheErro), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.baixaPlanilha(_ctx.arquivo))),
              disabled: _ctx.loadingBaixarPlanilha,
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              (_ctx.loadingBaixarPlanilha)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                : (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32)),
              _createTextVNode(" Baixar ")
            ], 8, _hoisted_26),
            _createElementVNode("button", {
              disabled: _ctx.arquivo.erro || _ctx.arquivo.status == 'concluído' || _ctx.loadingRodaPlanilha,
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.rodandoFila && _ctx.rodaPlanilha())),
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              (_ctx.rodandoFila)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                : (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39)),
              _createTextVNode(" Rodar ")
            ], 8, _hoisted_33)
          ])
        ])
      ])
    ])
  ]))
}